import { BackLink } from './BackLink'

interface DetailBarProps {
  back: { href: string; label: string }
  /** Status beside the back link: a Draft chip, the autosave word. */
  children?: React.ReactNode
  /** Right-aligned controls. The single gold on the view belongs here. */
  actions?: React.ReactNode
}

/**
 * The sticky utility bar atop a 760px detail/editor view.
 *
 * `top-[60px]` below `lg`: the app's TopBar is sticky at 60px there and this
 * bar sat underneath it, taking the actions and the save status with it the
 * moment the reader scrolled. Above `lg` the TopBar is static and `main` is
 * the scroll container, so 0 is right.
 *
 * The height is fixed at `h-14` on purpose: the article RichTextarea toolbar
 * stacks under it at `top-[116px] lg:top-14`, so this number is load-bearing.
 */
export function DetailBar({ back, children, actions }: DetailBarProps) {
  return (
    <div className="sticky top-[60px] lg:top-0 z-20 bg-bg-page/95 backdrop-blur border-b border-border-default">
      <div className="max-w-[760px] mx-auto px-5 sm:px-8 h-14 flex items-center gap-3 sm:gap-4">
        <BackLink href={back.href} label={back.label} />
        {children}
        {actions && <div className="ml-auto flex items-center gap-2 flex-shrink-0">{actions}</div>}
      </div>
    </div>
  )
}
